module.exports = __webpack_public_path__ + "static/media/4.6d7170d1.png";